import { FormHelperText, Input, InputLabel, Toolbar } from '@mui/material'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { updateUserid, updateUsername } from '../../../store/userSlice'
import styled from 'styled-components'
import TextBox from '../../Common/TextBox'
import { BlueButton } from '../../Layout/CommonStyle'
import { useEffect, useState } from 'react'
import { axiosPost } from '../../Common/Axios'
import toast from 'react-hot-toast'
import { ApiResult } from '../../../models/Enums'
import MainInfo from './MainInfo'
import MainPasswd from './MainPasswd'

type Props = {
  menuIndex: number
}

function Main(props: Props) {
  return <div>{props.menuIndex === 0 ? <MainInfo /> : <MainPasswd />}</div>
}

export default Main
